export default "<h1>My Basic Calculator</h1>\n<calculator></calculator>\n<about></about>\n"